(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auvenne-legame-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const bundle = document.querySelector('[data-legame-bundle]');
    if (!bundle || bundle.dataset.ready) return;
    const form = bundle.closest('form');
    const root = bundle.closest('[data-legame-pdp]');
    if (!form || !root) return;
    const data = JSON.parse(bundle.querySelector('[data-legame-data]').textContent);
    const second = bundle.querySelector('[data-legame-second]');
    const secondWrap = bundle.querySelector('[data-legame-second-wrap]');
    const pairButtons = Array.from(bundle.querySelectorAll('[data-legame-pair]'));
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:data.currency, maximumFractionDigits:2 }).format(value/100);
    const put = (selector, value) => { const node=bundle.querySelector(selector); if (node.textContent !== value) node.textContent=value; };
    const update = () => {
      const first = data.variants.find(v=>String(v.id)===form.querySelector('[data-lu-varid]').value);
      const other = data.variants.find(v=>String(v.id)===second.value);
      if (!first || !other) return;
      const two = bundle.querySelector('[name=legame_quantity]:checked').value==='2';
      const discountable = (!first.compare || first.compare<=first.price) && (!other.compare || other.compare<=other.price);
      const full = first.price + other.price;
      const pair = discountable ? full-Math.round(first.price*.15)-Math.round(other.price*.15) : full;
      const total = two ? pair : first.price;
      secondWrap.hidden=!two; second.disabled=!two;
      put('[data-legame-one-price]', money(first.price));
      put('[data-legame-two-price]', money(pair));
      put('[data-legame-original]', discountable?money(full):'');
      put('[data-legame-saving]', money(full-pair));
      put('[data-legame-total]', money(total));
      put('[data-legame-shipping]', data.shippingThreshold>0&&total>=data.shippingThreshold?data.copy.free:data.copy.paid);
      const image=bundle.querySelector('[data-legame-second-image]');
      if (image.getAttribute('src')!==other.image) image.src=other.image;
      image.alt=other.product+' · '+other.title;
      put('[data-legame-selected-label]', other.product+' · '+other.title+' · '+money(other.price));
      pairButtons.forEach(button=>{
        const selected=button.dataset.productHandle===other.handle;
        button.classList.toggle('is-selected',selected);
        button.setAttribute('aria-selected',selected?'true':'false');
      });
      if(form.dataset.auvOldPdpAdding==='1')return;
      const available=first.available&&(!two||other.available);
      const label=available?(two?data.copy.two:data.copy.one):data.copy.sold;
      [form.querySelector('[data-lu-add]'),document.querySelector('[data-lu-sticky-add]')].forEach(button=>{if(button){button.textContent=label;button.disabled=!available;}});
      const stickyPrice=document.querySelector('[data-lu-sticky-price]');
      if(stickyPrice)stickyPrice.textContent=money(total);
    };
    pairButtons.forEach(button=>button.addEventListener('click',()=>{
      second.value=button.dataset.variantId;
      second.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    bundle.dataset.ready='true';bundle.hidden=false;
    form.addEventListener('change',()=>requestAnimationFrame(update));
    document.addEventListener('auvenne:cart-synced',()=>requestAnimationFrame(update));
    window.addEventListener('pageshow',()=>requestAnimationFrame(update));
    update();
    requestAnimationFrame(update);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["auvenne-product-choice-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{const form=event.target.closest('form');if(!form)return;const summary=form.querySelector('[data-site-initials] strong');if(summary){const letters=[...form.querySelectorAll('select[name^="properties["]')].map(x=>x.value||'—');summary.textContent=letters.join(' + ');}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  const copyNode = document.getElementById('cro-ui-copy');
  if (!copyNode) return;
  const copy = JSON.parse(copyNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const reviewLine = document.querySelector('[data-cro-overall]');
  if (reviewLine) fetch('https://auvenne-circle-production.up.railway.app/api/reviews?overall=true').then(response => response.ok ? response.json() : null).then(data => {
    const average = Number(data?.summary?.average), count = Number(data?.summary?.count);
    if (!(count > 0 && average >= 1 && average <= 5)) return;
    reviewLine.textContent = reviewLine.dataset.template.replace('__AVG__', new Intl.NumberFormat(document.documentElement.lang,{maximumFractionDigits:1}).format(average)).replace('__COUNT__',String(count));
  }).catch(() => {});
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-cro-close-choice]');
    if (close) {
      const details = close.closest('details');
      details.open = false;
      details.querySelector('summary').focus();
    }
    const summary = event.target.closest('.cro-card__choice summary');
    if (summary && !summary.parentElement.open) document.dispatchEvent(new CustomEvent('quick_add_variant_open', {detail:{product_handle:summary.closest('[data-product-handle]').dataset.productHandle}}));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.cro-card__choice[open]');
    if (details) {details.open = false; details.querySelector('summary').focus();}
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-cro-add-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy || !form.reportValidity()) return;
    const button = form.querySelector('[type=submit]');
    const status = form.querySelector('[data-cro-status]');
    form.dataset.busy = 'true'; button.disabled = true; status.textContent = copy.loading;
    try {
      const data = new FormData(form);
      data.set('sections','cart-drawer,cart-icon-bubble');
      data.set('sections_url',location.pathname);
      const response = await fetch(root + 'cart/add.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('add_failed');
      const result = await response.json();
      status.textContent = copy.added;
      if (window.AUVENNECartDrawer?.render) {
        await window.AUVENNECartDrawer.render(result,button);
        const first = document.querySelector('cart-drawer .cart-item a');
        if (first) first.focus();
      } else location.assign(root + 'cart');
    } catch {
      status.textContent = copy.error;
    } finally {delete form.dataset.busy; button.disabled = false;}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
